const API_URL =
  process.env.NEXT_PUBLIC_API_URL || process.env.EXPO_PUBLIC_API_URL

const CUSTOM_API_URL = process.env.NEXT_PUBLIC_CUSTOM_API_URL || API_URL

export const API_WS_URL =
  process.env.NEXT_PUBLIC_API_WS_URL || process.env.EXPO_PUBLIC_API_WS_URL

const getAPIURL = (path: string) => API_URL + path
const getCustomAPIURL = (path: string) => CUSTOM_API_URL + path
const LB_API_URL = API_URL //'https://node1.ledgerbytes.tech'
const getLedgerBytesAPIURL = (path: string) => LB_API_URL + path

type PayloadObject = Record<string, string | number | boolean | undefined>

const VercelHeader: Record<string, string> = {
  'X-Vercel': 'nomoneh',
}

export interface ModulusAPIResponse<T> {
  status: 'Success' | 'Error'
  message?: string | null
  data?: T | null
  field?: string
}

export type ModulusPaginatedData<T> = {
  rows: T[]
  totalRows: number
  currentPage: number
  pageSize: number
}

export const wrapModulusAPIResponse = <T>(
  data: T,
  message: string | null = null,
): ModulusAPIResponse<T> => {
  return {
    status: 'Success',
    message,
    data,
  }
}

const getFetchBody = (isFormEncoded: boolean, payload: PayloadObject) => {
  if (!isFormEncoded) return JSON.stringify(payload)

  return new URLSearchParams(
    Object.entries(payload).reduce(
      (acc, [key, value]) => {
        if (value !== undefined) acc[key] = String(value)
        return acc
      },
      {} as Record<string, string>,
    ),
  ).toString()
}

interface GetAPIOptions {
  accessToken?: string | null
  ledgerBytesAPI?: boolean
  customAPI?: boolean
}
//https://node1.ledgerbytes.tech/market/get-chart-data

export const getAPI = async <T>(
  path: string,
  { accessToken, ledgerBytesAPI, customAPI }: GetAPIOptions = {},
): Promise<ModulusAPIResponse<T>> => {
  const headers: Record<string, string> = {
    Accept: 'application/json',
    ...VercelHeader,
  }
  if (accessToken) {
    headers['Authorization'] = `Bearer ${accessToken}`
  }

  const url = (() => {
    if (ledgerBytesAPI) {
      return getLedgerBytesAPIURL(path)
    } else if (customAPI) {
      return getCustomAPIURL(path)
    }
    return getAPIURL(path)
  })()

  const response = await fetch(url, {
    method: 'GET',
    headers,
  })

  const result = await handleFetchResponse<T>(response)

  return result
}

const handleFetchResponse = async <T>(
  response: Response,
): Promise<ModulusAPIResponse<T>> => {
  if (!response.ok) {
    const error = await response.json()
    console.log('ERROR', error)
    const message = error.message ?? error.Message ?? 'Internal server error'

    return {
      status: 'Error',
      message,
      data: null,
    } as ModulusAPIResponse<T>
  }

  const result = await response.json()

  // Wrap and normalize response data
  if (!result.status && !result.data) {
    return {
      status: 'Success',
      message: 'Success',
      data: result as T,
    } as ModulusAPIResponse<T>
  }

  return result as ModulusAPIResponse<T>
}

type PostAPIOptions = {
  isFormEncoded?: boolean
  accessToken?: string | null
  customAPI?: boolean
}
export const postAPI = async <T>(
  path: string,
  payload: PayloadObject = {},
  options: PostAPIOptions = {},
): Promise<ModulusAPIResponse<T>> => {
  const { isFormEncoded = false, accessToken, customAPI } = options
  const contentType = isFormEncoded
    ? 'application/x-www-form-urlencoded'
    : 'application/json'

  const headers: Record<string, string> = {
    'Content-Type': contentType,
    Accept: 'application/json',
    ...VercelHeader,
  }
  if (accessToken) {
    headers['Authorization'] = `Bearer ${accessToken}`
  }

  const urlPath = customAPI ? getCustomAPIURL(path) : getAPIURL(path)

  console.log('POST', urlPath, payload, headers)

  const response = await fetch(urlPath, {
    method: 'POST',
    headers,
    body: getFetchBody(isFormEncoded, payload),
  })

  const result = await handleFetchResponse<T>(response)
  console.log('[POST] Response', result)
  return result
}
